import React, { FC, HTMLAttributes } from 'react';
import PropTypes from 'prop-types';

type OptionProps = HTMLAttributes<HTMLOptionElement> & {
  value: string;
  disabled?: boolean;
};

export const Option: FC<OptionProps> = ({
  value,
  disabled,
  children,
  ...rest
}) => {
  return (
    <option value={value} disabled={disabled} {...rest}>
      {children}
    </option>
  );
};

Option.propTypes = {
  value: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};
